<template>
  <div class="hm-editor flex">
    <div>
      <quill-editor
        class="editor"
        v-model="content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
        @paste="onEditorPaste($event)"
      ></quill-editor>
      <el-dialog
        width="880px"
        title="图片上传"
        :visible.sync="dialogVisible"
        :modal="false"
      >
        <div class="content">
          <div class="flex flex-between item-center">
            <div class="tips">
              允许用户同时上传20张照片，单张图片容量不超过1MB,
              <span style="color:red">可拖拽调整顺序</span>
            </div>
            <el-upload
              class="editor-upload mr10"
              ref="editorUpload"
              :limit="20"
              multiple
              :show-file-list="false"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :on-remove="handleRemove"
              :onError="uploadError"
              :onSuccess="handleSuccess"
              :on-progress="onProgress"
              :beforeUpload="beforeUpload"
            >
              <!-- <div class="el-upload--picture-card">
                  上传
                </div> -->
              <el-button size="small" type="success">上传</el-button>
            </el-upload>
          </div>
          <div class="img-wrapper p20">
            <ul class="flex">
              <draggable class="flex flex-wrap" :list="imgList">
                <li
                  class="el-upload--picture-card"
                  :class="{ ml160: i === 0 }"
                  @click="removeImg(i)"
                  v-for="(v, i) in imgList"
                  :key="i"
                >
                  <div class="No">
                    <el-badge :value="i + 1" class="flex item-start">
                    </el-badge>
                  </div>
                  <div class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-check"></i>
                  </div>
                  <img class="img" :src="v" alt="" />
                  <div class="el-upload-list__item-actions flex flex-center">
                    <span class="hmicon  icon-shanchu"></span>
                  </div>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-end">
          <el-button size="small" type="primary" @click="insertAll"
            >全部插入</el-button
          >
          <el-button size="small" type="warning" @click="removeAll"
            >全部清除</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" width="50%" style="margin-top: 1px" title="视频上传" :visible.sync="videoForm.show" append-to-body>
        <el-tabs v-model="videoForm.activeName">
          <el-tab-pane label="添加视频链接" name="first">
            <el-input v-model="videoForm.videoLink" placeholder="请输入视频链接" clearable></el-input>
            <el-button type="primary" size="small" style="margin: 20px 0px 0px 0px " @click="insertVideoLink(videoForm.videoLink)">确认
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="本地视频上传" name="second">
            <el-upload v-loading="loading" style="text-align: center;" drag :data="{ fileDir: videoDir}" :action="$uploadVideoUrl" :headers="{ 'X-Access-Token': $token }" accept="video/*" :before-upload="onBeforeUploadVideo" :on-success="onSuccessVideo" :on-error="onErrorVideo" :multiple="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传MP4文件，且不超过{{uploadVideoConfig.maxSize}}M</div>
            </el-upload>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
    <div class="rich-text-preview">
      <div class="header">图文详情预览</div>
      <div class="rich-scroll-bar">
        <div class="ql-container ql-snow">
          <div class="ql-editor">
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLoginUser } from "@/utils/auth";
import { Loading } from "element-ui";
import draggable from "vuedraggable";

// 工具栏配置
const toolbarOptions = [
  ['emoji', "bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  // [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  // [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  // [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "video", "image"] // 链接、图片、视频
];

import { Quill,quillEditor } from "vue-quill-editor";
import Delta from 'quill-delta';
import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import Video from './quill/quill-video'
Quill.register(Video, true)
Quill.register('modules/quillEmoji', quillEmoji)
export default {
  props: {
    /*编辑器的内容*/
    value: {
      type: String
    },
    /*图片大小*/
    maxSize: {
      type: Number,
      default: 4000 //kb
    },
    html: {
      type: String
    },
    // 视频上传配置
    uploadVideoConfig: {
      type: Object,
      default () {
        return {
          uploadUrl: '', // 上传地址
          maxSize: 10, // 图片上传大小限制，默认不超过2M
          name: 'Filedata' // 图片上传字段
        }
      }
    }
  },

  components: {
    quillEditor,
    draggable
  },

  mounted() {
    const { storeId } = getLoginUser();
    this.storeId = storeId;

    //防抖
    this.handleSuccess = _.debounce(this.uploadSuccess, 1000);
  },

  watch: {
    html(val) {
      // 防止加载后页面滚动至富文本编辑器
      if (this.$refs.myQuillEditor.quill) {
        if (val && val !== this.content) {
          // 渲染文本到页面
          this.content = val;
          this.$refs.myQuillEditor.quill.setContents(
            this.$refs.myQuillEditor.quill.clipboard.convert(val)
          );
        } else if (!val) {
          this.$refs.myQuillEditor.quill.setText("");
        }
      }
    },
    blur(val) {
      if (val) {
        this.$nextTick(function() {
          this.$refs.myQuillEditor.quill.enable(true);
          this.$refs.myQuillEditor.quill.blur();
        });
      }
    },
    value(val) {
      if(val) {
        this.content = val
      }
    }
  },

  data() {
    let _self = this;
    return {
      videoDir: "video",
      handleSuccess: null,
      imgList: [],
      blur: false,
      disabled: false,
      dialogVisible: false,
      content: this.value,
      loading: false,
      storeId: "",
      currentSelectionIndex: -1, // 使用 -1 表示未初始化
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        theme: "snow", // or 'bubble'
        placeholder: "请输入图文详情",
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              image: val => {
                if (val) {
                  // document.querySelector(".editor-upload input").click();
                  this.dialogVisible = true;
                  let quill = this.$refs.myQuillEditor.quill;
                  this.currentSelectionIndex = quill.getSelection().index;
                } else {
                  this.$refs.myQuillEditor.quill.format("image", false);
                }
              },
              video: val => {
                // 覆盖默认的上传视频，点击视频图标，显示弹窗
                _self.videoForm.show = true
              }
            }
          },
          clipboard: {
            matchers: [
              ['img', function(node, delta) {
                const src = node.getAttribute('src');
                if (!src) return new Delta();

                // ==============================================
                // 1. 浏览器安全策略限制拦截本地路径 file:/// → 提示用户
                // ==============================================
                if (src.startsWith('file:///')) {
                  _self.$message.warning('检测到本地图片路径，请使用图片上传功能');
                  return new Delta();
                }

                // ==============================================
                // 2. 处理 Base64 图片（截图/微信复制/Word内嵌图）
                // ==============================================
                if (src.startsWith('data:image')) {
                  // 优先使用 currentSelectionIndex（由 onEditorChange 持续更新）
                  // 如果为 -1（未初始化），则尝试获取当前光标位置
                  const quill = _self.$refs.myQuillEditor?.quill;
                  let currentIndex = _self.currentSelectionIndex;

                  if (currentIndex === -1 && quill) {
                    const range = quill.getSelection();
                    if (range) {
                      currentIndex = range.index;
                    } else {
                      currentIndex = quill.getLength();
                    }
                  }

                  _self.handleBase64Image(src, currentIndex);
                  return new Delta();
                }

                // 网络图片正常通过
                return delta;
              }]
            ]
          }
        }
      },
      header: {}, // 有的图片服务器要求请求头需要有token
      // 视频上传变量
      videoForm: {
        show: false, // 显示插入视频链接弹框的标识
        videoLink: '',
        activeName: 'first'
      }
    };
  },

  methods: {
    handlePictureCardPreview() {},
    handleDownload() {},
    onEditorBlur() {
      //失去焦点事件
      // 保存当前光标位置，以便粘贴时使用
      const quill = this.$refs.myQuillEditor?.quill;
      if (quill) {
        const range = quill.getSelection();
        if (range) {
          this.currentSelectionIndex = range.index;
        }
      }
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
      this.$emit("input", this.content);
      // 持续跟踪光标位置
      const quill = this.$refs.myQuillEditor?.quill;
      if (quill) {
        const range = quill.getSelection();
        if (range) {
          this.currentSelectionIndex = range.index;
        }
      }
    },

    /**
     * 处理编辑器粘贴事件
     * 支持从文件管理器复制图片文件粘贴
     */
    onEditorPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      // 首先保存当前光标位置（在任何操作之前）
      // 优先使用 currentSelectionIndex（由 onEditorChange 持续更新）
      let currentIndex = this.currentSelectionIndex;

      // 如果为 -1（未初始化），则尝试获取当前光标位置
      const quill = this.$refs.myQuillEditor?.quill;
      if (currentIndex === -1 && quill) {
        const range = quill.getSelection();
        if (range) {
          currentIndex = range.index;
        } else {
          currentIndex = quill.getLength();
        }
      }

      const items = clipboardData.items;

      // ==============================================
      // 1. 优先处理剪贴板中的图片文件（从文件管理器复制）
      // ==============================================
      if (items) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];

          // 处理图片文件类型
          if (item.type.indexOf('image') !== -1) {
            event.preventDefault();
            event.stopPropagation();

            // 获取图片文件
            const blob = item.getAsFile();
            if (blob) {
              this.handlePasteImageFile(blob, currentIndex);
            }
            return;
          }
        }
      }

      // ==============================================
      // 2. 处理 HTML 内容中的 base64 图片（截图/Word粘贴）
      // ==============================================
      const html = clipboardData.getData('text/html');
      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const images = doc.querySelectorAll('img');

        let hasBase64Image = false;
        images.forEach(img => {
          const src = img.getAttribute('src') || '';
          if (src.startsWith('data:image')) {
            hasBase64Image = true;
            event.preventDefault();
            event.stopPropagation();
            this.handleBase64Image(src, currentIndex);
          }
        });
      }
    },

    /**
     * 处理粘贴的图片文件（从文件管理器复制）
     * @param {File} file - 图片文件
     * @param {number} insertIndex - 插入位置
     */
    async handlePasteImageFile(file, insertIndex) {
      await this.uploadImageFile(file, insertIndex);
    },

    /**
     * 通用图片上传方法
     * @param {File} file - 图片文件
     * @param {number} insertIndex - 插入位置
     */
    async uploadImageFile(file, insertIndex) {
      try {
        // 显示 loading
        this.loading = Loading.service({
          lock: true,
          text: "图片上传中",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)"
        });

        // 使用传入的光标位置
        let quill = this.$refs.myQuillEditor.quill;
        let index = insertIndex;

        // 验证文件
        if (!this.beforeUpload(file)) {
          this.loading.close();
          return;
        }

        // 创建 FormData
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileDir', 'mall');

        // 调用上传接口
        const response = await this.uploadFile(formData);

        if (response.code === 0 || response.code === "0") {
          // 上传成功，插入图片到保存的光标位置
          const imageUrl = response.result;
          quill.insertEmbed(index, "image", imageUrl);
          quill.setSelection(index + 1);
          this.$message.success("图片上传成功");
        } else {
          this.$message.error(response.desc || "图片上传失败");
        }
      } catch (error) {
        console.error("图片上传失败:", error);
        this.$message.error("图片上传失败");
      } finally {
        this.loading.close();
      }
    },

    onProgress() {
      this.loading = Loading.service({
        lock: true,
        text: "卖力上传中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0)"
      });
    },
    removeImg(i) {
      this.imgList.splice(i, 1);
    },
    // 富文本图片上传前
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      const limitSize = file.size / 1024 <= 1024;
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1MB!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
      // 显示loading动画
      // this.$refs.myQuillEditor.quillUpdateImg = true;
      // this.loading = Loading.service({
      //   lock: true,
      //   text: "上传中请勿移动鼠标",
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0)"
      // });
    },
    removeAll() {
      this.imgList = [];
      this.$refs.editorUpload.clearFiles();
    },
    insertAll() {
      if (this.imgList.length > 0) {
        this.dialogVisible = false;
        let quill = this.$refs.myQuillEditor.quill;
        let insertIndex = this.currentSelectionIndex;
        if (insertIndex === -1) {
          insertIndex = quill.getLength();
        }
        this.imgList.forEach(v => {
          quill.insertEmbed(insertIndex, "image", v);
          insertIndex++;
        });
        quill.setSelection(insertIndex);
      } else {
        this.$message({
          message: "请先上传图片",
          type: "warning"
        });
      }
    },
    async uploadSuccess(response, file, fileList) {
      try {
        for (let fileInfo of fileList) {
          if (fileInfo.status === "success") {
            let imageInfo = await fileInfo.response.result;
            this.imgList.push(imageInfo);
          } else {
            this.$message.warning("请检查图片是否错漏");
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      } finally {
        this.loading.close();
        this.$refs.editorUpload && this.$refs.editorUpload.clearFiles();
      }
    },
    // uploadSuccess(res, file, fileList) {
    //   console.log("file: ", file);
    //   console.log("res: ", res);
    //   console.log("fileList: ", fileList);
    //   fileList.forEach(v => {
    //     // console.log("vuploadSuccess: ", v.response.code);
    //     // if (v.response.code === "0") {
    //     this.imgList.push(v.response.result);
    //     // }
    //   });
    //   this.loading.close();
    //   this.$refs.editorUpload && this.$refs.editorUpload.clearFiles();

    //   // if (res.code == "0") {
    //   //   this.imgList.push(res.result);
    //   // }
    //   // res为图片服务器返回的数据
    //   // 获取富文本组件实例
    //   // let quill = this.$refs.myQuillEditor.quill;
    //   // // 如果上传成功
    //   // if (res.code == "0") {
    //   //   // 获取光标所在位置
    //   //   let length = quill.getSelection().index;
    //   //   // 插入图片  res.url为服务器返回的图片地址
    //   //   quill.insertEmbed(length, "image", res.result);
    //   //   // 调整光标到最后
    //   //   quill.setSelection(length + 1);
    //   // } else {
    //   //   this.$message.error("图片插入失败");
    //   // }
    //   // // loading动画消失
    //   // this.$refs.myQuillEditor.quillUpdateImg = false;
    //   // this.loading.close();
    // },
    handleRemove(file, fileList) {
      // this.imgList = fileList.map(v => v.response && v.response.result);
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      // this.$refs.myQuillEditor.quillUpdateImg = false;
      // this.loading.close();
      this.loading.close();
      this.$message.error("图片插入失败");
    },
    /** --------- 视频上传相关 start ---------  */
    hideLoading () {
      this.loading = false
    },
    insertVideoLink (videoLink, poster) {
      if (!videoLink) return this.$message.error('视频地址不能为空！')
      this.videoForm.show = false
      let quill = this.$refs.myQuillEditor.quill;
      // 获取富文本
      let range = quill.getSelection()
      // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
      let index = range ? range.index : 0
      // 没有视频默认封面时，设置默认视频封面图片
      const img = poster ? poster : ''
      // 在光标所在位置 插入视频
      quill.insertEmbed(index, 'video', {
        url: videoLink,
        poster: img
      })
      // 调整光标到最后
      quill.setSelection(index + 1)
    },
    // el-文件上传组件
    onBeforeUploadVideo (file) {
      this.loading = true
      let acceptArr = ['video/mp4']
      const isVideo = acceptArr.includes(file.type)
      const isLt1M = file.size / 1024 / 1024 < this.uploadVideoConfig.maxSize
      if (!isVideo) {
        this.hideLoading()
        this.$message.error('只能上传mp4格式文件!')
      }
      if (!isLt1M) {
        this.hideLoading()
        this.$message.error(`上传文件大小不能超过 ${this.uploadVideoConfig.maxSize}MB!`)
      }
      return isLt1M && isVideo
    },
    // 文件上传成功时的钩子
    onSuccessVideo (res) {
      this.hideLoading()
      if (res.code == 0) {
        this.insertVideoLink(res.result);
      } else {
        this.$message.error(res.desc)
      }
    },
    // 文件上传失败时的钩子
    onErrorVideo () {
      this.hideLoading()
      this.$message.error('上传失败')
    },
    /**--------- 视频上传相关 end --------- */

    /**
     * 处理 base64 图片粘贴
     * 将 base64 转换为文件并上传
     * @param {string} base64String - base64 图片数据
     * @param {number} insertIndex - 插入位置
     */
    async handleBase64Image(base64String, insertIndex) {
      // 将 base64 异步转换为文件（避免阻塞主线程）
      const file = await this.base64ToFile(base64String);
      // 复用通用上传方法
      await this.uploadImageFile(file, insertIndex);
    },

    /**
     * 将 base64 字符串转换为 File 对象（异步，避免阻塞主线程）
     * @param {string} base64String - base64 图片数据
     * @returns {Promise<File>} - 转换后的 File 对象
     */
    async base64ToFile(base64String) {
      // 解析 base64 字符串获取 mime 类型
      const arr = base64String.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];

      // 根据 mime 类型确定文件扩展名，并进行安全验证
      let ext = mime.split('/')[1] || 'png';
      const allowedExts = ['jpg', 'jpeg', 'png', 'bmp'];
      if (!allowedExts.includes(ext.toLowerCase())) {
        ext = 'png';
      }

      const filename = `pasted_image_${Date.now()}.${ext}`;

      // 使用 fetch API 异步转换 base64 为 Blob，避免阻塞主线程
      const response = await fetch(base64String);
      const blob = await response.blob();

      return new File([blob], filename, { type: mime });
    },

    /**
     * 上传文件
     */
    uploadFile(formData) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.$uploadUrl, true);
        xhr.setRequestHeader('X-Access-Token', this.$token);

        xhr.onload = function() {
          if (xhr.status === 200) {
            try {
              const response = JSON.parse(xhr.responseText);
              resolve(response);
            } catch (e) {
              reject(new Error('解析响应失败'));
            }
          } else {
            reject(new Error('上传失败'));
          }
        };

        xhr.onerror = () => reject(new Error('网络请求失败'));
        xhr.send(formData);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hm-editor {
  position: relative;
  // .hmicon {
  //   position: absolute;
  //   right: 10px;
  //   top: 2px;
  //   font-weight: bold;
  //   cursor: pointer;
  // }
}

.rich-text-preview {
  width: 375px;
  margin-left: 20px;
  height: 562px;
  border: 1px dashed #e50065;
  .header {
    background: #e50065;
    color: #fff;
    width: 114px;
    text-align: center;
  }
  .rich-scroll-bar {
    height: 500px;
    width: 375px;
    overflow-y: auto;
    .ql-snow {
      border: none;
    }
    .ql-editor {
      padding: 0;
    }
    img {
      display: block;
      width: 375px;
    }
  }
}

.img-wrapper {
  height: 320px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin: 20px 0;
}

.editor {
  line-height: normal !important;
  height: 500px;
  margin-bottom: 50px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}

.el-upload--picture-card {
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  margin-right: 10px;
  .No {
    position: absolute;
    top: 10px;
    left: 10px;
  }
  &:hover {
    .el-upload-list__item-actions {
      opacity: 1;
    }
    .el-upload-list__item-status-label {
      display: none;
    }
    .iconfont {
      position: static;
    }
  }
  .img {
    width: 100%;
    height: 100%;
  }
  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
  }
  .el-upload-list__item-status-label {
    position: absolute;
    right: -15px;
    top: -6px;
    width: 40px;
    height: 24px;
    background: #13ce66;
    text-align: center;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: block;
    i {
      color: #ffffff;
      font-size: 12px;
      margin-top: 11px;
      display: block;
      transform: rotate(-45deg);
    }
  }
}
</style>
